import React from 'react';
import Divider from '../components/Divider';

export default class WhoAreWe extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    render() {
        return (
            <div className="container">
                <Divider />
                <div>
                    <div
                        className="big-title animated fadeInDown delay-01"
                        data-animation="fadeInDown"
                        data-animation-delay="01"
                    >
                        <h2 className="iwh-title">
                            STAP<span className="accent-color">MEDIF</span>, une
                            offre exclusivement dédiée à l'imagerie médicale
                        </h2>
                    </div>
                    <p>
                        <b>STAPMEDIF</b> est née du constat que les{' '}
                        <b>centres d’appels</b> traditionnels ne sont pas en
                        mesure d’apporter une réponse appropriée aux
                        particularités de l’<b>imagerie médicale</b>. Votre
                        activité revêt des enjeux spécifiques : confiez la{' '}
                        <b>gestion de vos appels et de vos rendez-vous</b> à des
                        professionnels spécialisés.
                    </p>
                </div>
                <Divider type="5" />
                <div>
                    <div
                        className="big-title animated fadeInDown delay-01"
                        data-animation="fadeInDown"
                        data-animation-delay="01"
                    >
                        <h2 className="iwh-title">
                            Notre{' '}
                            <span className="accent-color">expérience</span>{' '}
                            fait la différence
                        </h2>
                    </div>
                    <p>
                        Fruit de la collaboration entre des{' '}
                        <b>médecins radiologues</b> et des experts techniques
                        présents de longue date dans le secteur de la santé,{' '}
                        <b>STAPMEDIF</b> a développé des services de{' '}
                        <b>télésecrétariat</b> adaptés aux exigences des{' '}
                        <b>centres d’imagerie médicale</b> :
                    </p>
                    <div className="shortcode-simple-list icon">
                        <ul>
                            <li>
                                <i className="accent-color fa fa-hand-o-right"></i>
                                un accueil téléphonique professionnel sur une
                                large amplitude
                            </li>
                            <li>
                                <i className="accent-color fa fa-hand-o-right"></i>
                                un planning de rendez-vous élaboré dans le
                                respect de vos instructions
                            </li>
                            <li>
                                <i className="accent-color fa fa-hand-o-right"></i>
                                une ingénierie technique de dernière génération,
                                fiable et sécurisée
                            </li>
                            <li>
                                <i className="accent-color fa fa-hand-o-right"></i>
                                une offre commerciale flexible selon vos
                                besoins, sans engagement
                            </li>
                        </ul>
                    </div>
                </div>
                <Divider type="5" />
                <div>
                    <div
                        className="big-title animated fadeInDown delay-01"
                        data-animation="fadeInDown"
                        data-animation-delay="01"
                    >
                        <h2 className="iwh-title">
                            Nos secrétaires sont vos secrétaires
                        </h2>
                    </div>
                    <p>
                        Nos <b>secrétaires médicales</b> diplômées sont toutes
                        spécifiquement formées pour l’
                        <b>
                            accueil téléphonique et la prise de rendez-vous en
                            imagerie médicale
                        </b>
                        . Elles maitrisent tous les aspects de votre profession
                        : terminologie, pratiques des{' '}
                        <b>médecins radiologues</b>, organisation des vacations,
                        contraintes spécifiques des examens. Rigoureuses et
                        conviviales, elles informent et orientent vos patients
                        en toutes circonstances.
                    </p>
                </div>
                <Divider type="5" />
                <div>
                    <div
                        className="big-title animated fadeInDown delay-01"
                        data-animation="fadeInDown"
                        data-animation-delay="01"
                    >
                        <h2 className="iwh-title">
                            Une plateforme et des compétences 100 % françaises
                        </h2>
                    </div>
                    <p>
                        <b>STAPMEDIF</b> a fait le choix de s’implanter en
                        Vendée, un territoire reconnu pour sa qualité de vie et
                        son dynamisme économique. Lors de l’aménagement de nos
                        locaux, une attention particulière a été portée au
                        confort de nos collaboratrices et à l’ergonomie des
                        postes de travail. Soucieux de proposer une offre
                        qualitative et performante, <b>STAPMEDIF</b> s’engage :
                        nous garantissons que toutes les communications sont
                        réceptionnées sur notre <b>centre d’appels</b>
                        &nbsp;et traitées par nos <b>secrétaires médicales</b>.
                    </p>
                </div>
                <Divider type="5" />
                <div>
                    <div
                        className="big-title animated fadeInDown delay-01"
                        data-animation="fadeInDown"
                        data-animation-delay="01"
                    >
                        <h2 className="iwh-title">
                            Une présence nationale, un accompagnement de
                            proximité
                        </h2>
                    </div>
                    <p>
                        Structure agile et dynamique, <b>STAPMEDIF</b>{' '}
                        accompagne partout en France les groupes d’
                        <b>imagerie médicale</b> dans l’
                        <b>externalisation de leur secrétariat</b>.{' '}
                        <b>
                            Cabinets de radiologie conventionnelle, plateaux
                            d’imagerie en coupe, établissements de santé
                        </b>{' '}
                        : nos solutions sont disponibles où que vous soyez.
                        N’attendez plus pour optimiser votre activité en toute
                        sérénité. Rejoignez les plus de 600 praticiens qui nous
                        font déjà confiance ! Contactez-nous.
                    </p>
                </div>
                <Divider />
            </div>
        );
    }
}

WhoAreWe.propTypes = {};



// WEBPACK FOOTER //
// ./src/routes/WhoAreWe.jsx